import React from 'react';

import { BaseDropDown } from './dropdowns';


type TBooleanDropdownProps = {
    onFilterChange: () => void;
    currentUrlParams: any;
    filterKey: string;
    falseLabel: string;
    trueLabel: string;
};

export default function BooleanDropdown({
    onFilterChange,
    currentUrlParams,
    filterKey,
    falseLabel,
    trueLabel,
}: TBooleanDropdownProps) {

    const options = [
        { label: falseLabel, value: 'false' },
        { label: trueLabel, value: 'true' },
        { label: 'All', value: '' },
    ];
    const selectedOption = currentUrlParams.get(filterKey);

    return (
        <>
            <BaseDropDown
                filterKey={filterKey}
                selected={selectedOption}
                options={options}
                defaultSelection={options[2]}
                onFilterChange={onFilterChange}
            />
        </>
    );
}
